export const formatAuthorLocation = (author: {
  affiliation?: string;
  city?: string;
  country?: string;
}) => {
  const parts = [
    author.affiliation?.trim(),
    author.city?.trim(),
    author.country?.trim()
  ].filter(Boolean);

  return parts.join(', ');
};

export const formatAuthorFull = (author: {
  firstName: string;
  lastName: string;
  affiliation?: string;
  city?: string;
  country?: string;
}) => {
  const location = formatAuthorLocation(author);
  return location
    ? `${author.firstName} ${author.lastName}, ${location}`
    : `${author.firstName} ${author.lastName}`;
};
